/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current stream status
 * @export
 */
export const StreamStatus = {
    OFFLINE: 'OFFLINE',
    LIVE: 'LIVE',
    STARTING: 'STARTING',
    ENDING: 'ENDING'
} as const;
export type StreamStatus = typeof StreamStatus[keyof typeof StreamStatus];


export function instanceOfStreamStatus(value: any): boolean {
    for (const key in StreamStatus) {
        if (Object.prototype.hasOwnProperty.call(StreamStatus, key)) {
            if (StreamStatus[key as keyof typeof StreamStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreamStatusFromJSON(json: any): StreamStatus {
    return StreamStatusFromJSONTyped(json, false);
}

export function StreamStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamStatus {
    return json as StreamStatus;
}

export function StreamStatusToJSON(value?: StreamStatus | null): any {
    return value as any;
}

export function StreamStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): StreamStatus {
    return value as StreamStatus;
}

